import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import React, { useEffect, useState } from 'react';
import { IPaginationParams } from '../../../../services/types';
import { getStreamByEndpointAsync } from '../../../../services/Events';
import { ENDPOINT_ALARM_CENTRAL_EVENT } from '../../../../services/AlarmCentralService';
import {
  useGetAllAlarmCentralEventByIdCountAsync,
  useGetAllAlarmCentralEventByLicenseCountAsync,
} from '../../../../services/AlarmCentralService/hooks/useMutations';
import PauseButtonComponent from 'components/PauseButtonComponent';
import { useLprEventDataStreamCache } from 'services/Events/LprEventsService/hooks/useQueryClient';
import { IEventPauseUpdateParams } from 'services/Events/types';
import { useTranslation } from 'react-i18next';

interface AlarmCentralEventsProps {
  alarmCentralId?: number;
}

const AlarmCentralEvents = ({ alarmCentralId }: AlarmCentralEventsProps) => {
  const { t } = useTranslation();
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [eventCount, setEventCount] = useState(0);
  const [events, setEvents] = useState<any[]>([]);

  const { mutateAsync: mutateGetAllAlarmCentralEventByLicenseCountAsync } =
    useGetAllAlarmCentralEventByLicenseCountAsync();
  const { mutateAsync: mutateGetAllAlarmCentralEventByIdCountAsync } =
    useGetAllAlarmCentralEventByIdCountAsync();
  const { setCacheData, getCacheData, clearCacheData } =
    useLprEventDataStreamCache();
  const [pausedUpdateParams, setPausedUpdateParams] =
    useState<IEventPauseUpdateParams>({
      isPaused: false,
      cacheKey: ENDPOINT_ALARM_CENTRAL_EVENT,
      setCacheData: setCacheData,
      getCacheData: getCacheData,
      clearCacheData: clearCacheData,
    });

  const onResponseStream = () => {
    if (alarmCentralId)
      mutateGetAllAlarmCentralEventByIdCountAsync(alarmCentralId).then(
        setEventCount,
      );
    else mutateGetAllAlarmCentralEventByLicenseCountAsync().then(setEventCount);
  };

  const columns: IColumnProps[] = [
    { id: 'description', label: t('common.description'), width: '30%' },
    { id: 'eventCode', label: t('alarmCentral.event'), width: '0%' },
    { id: 'account', label: t('alarmCentral.account'), width: '0%' },
    { id: 'zone', label: t('alarmCentral.zoneUser'), width: '0%' },
    { id: 'partition', label: t('alarmCentral.partition'), width: '0%' },
    {
      id: 'createdAt',
      label: t('alarmCentral.occurredAt'),
      width: '10%',
      render: (val) => <>{new Date(val).toLocaleString('pt-BR')}</>,
    },
  ];

  useEffect(() => {
    getStreamByEndpointAsync(
      alarmCentralId
        ? `v1/alarmCentral/${alarmCentralId}/events`
        : ENDPOINT_ALARM_CENTRAL_EVENT,
      setEvents,
      pagination,
      onResponseStream,
      undefined,
      undefined,
      !alarmCentralId,
    );
  }, [pagination, alarmCentralId]);

  useEffect(() => {}, [events]);
  // const columns = [
  //   { Header: 'Conta', accessor: 'account', align: 'left' },
  //   { Header: 'Evento', accessor: 'eventCode', align: 'left' },
  //   { Header: 'Partição', accessor: 'partition', align: 'left' },
  //   { Header: 'Zona', accessor: 'zone', align: 'left' },
  //   { Header: 'Descrição', accessor: 'description', align: 'left' },
  //   { Header: 'Foto', accessor: 'image', align: 'left' },
  //   { Header: 'Aconteceu em', accessor: 'createdAt', align: 'left' },
  // ];
  return (
    <TableComponent
      rows={events ?? []}
      additionalTitleComponent={
        <PauseButtonComponent
          pausedUpdateParams={pausedUpdateParams}
          setPausedUpdateParams={setPausedUpdateParams}
        />
      }
      totalCount={eventCount}
      emptyMessage={t('common.noItemsFound')}
      onChangePageOrRowsPerPage={setPagination}
      columns={columns}
    />
  );
};

export default AlarmCentralEvents;
